export default "__VITE_ASSET__BJP_Mf4C__"